import React, { memo } from 'react';
import { Box } from '@mafc/trolly';
import DynamicLoader from 'routes/DynamicLoader';
import useBinDiscountBanner from 'common/BinDiscountBanner/hooks/useBinDiscountBanner.hook';
import Container from './BinDiscountBanner.style';
import { IBinBanner } from './redux/binDiscountBanner.reducer';
import { PromotionLoader } from 'pages/Checkout/components/CheckoutLoader';

const BinBannerSlide = DynamicLoader(() =>
  import(/* webpackChunkName: "BinBannerSlide" */ './BinBannerSlide')
) as any;
const BinBannerCarousel = DynamicLoader(() =>
  import(/* webpackChunkName: "BinBannerCarousel" */ './BinBannerCarousel')
) as any;
const BinBannerHeading = DynamicLoader(() =>
  import(/* webpackChunkName: "BinBannerHeading" */ './BinBannerHeading')
) as any;

const getBannerDetails = (banners: IBinBanner[]) => {
  return banners.length > 1 ? (
    <BinBannerCarousel banners={banners} />
  ) : (
    <BinBannerSlide banner={banners[0]} index={0} />
  );
};

const BinDiscountBanner: React.FC<{
  hideBinLoading: boolean;
  isCheckoutPage?: boolean;
}> = ({ hideBinLoading, isCheckoutPage = false }) => {
  const binDiscountBannerState = useBinDiscountBanner();

  const banners = binDiscountBannerState && binDiscountBannerState.data;
  if (banners && banners.length) {
    if (hideBinLoading) {
      return (
        <Container>
          {!isCheckoutPage && <BinBannerHeading />}
          <Box>{getBannerDetails(banners)}</Box>
        </Container>
      );
    }
    return <PromotionLoader />;
  }
  return null;
};

export default memo(BinDiscountBanner);
